export default __webpack_public_path__ + "static/media/icons-20.cde033c5.eot";